var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sortTable" }, [
    _vm.sortTableConfig.titleStyle === "border"
      ? _c(
          "div",
          {
            class: _vm.sortTableConfig.dashedColor
              ? _vm.sortTableConfig.dashedColor
              : "title",
          },
          [_c("div", [_vm._v(_vm._s(_vm.sortTableConfig.title))])]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.sortTableConfig.titleStyle === "default"
      ? _c("div", { staticClass: "defaultTitle" }, [
          _c("div", [_vm._v(_vm._s(_vm.sortTableConfig.title))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("table", [
      _c("thead", [
        _c(
          "tr",
          [
            _vm.sortTableConfig.ranking ? _c("td", [_vm._v("排名")]) : _vm._e(),
            _vm._v(" "),
            _vm.sortTableConfig.product ? _c("td", [_vm._v("商品")]) : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.sortTableConfig.columns, function (th, thindex) {
              return _c("td", { key: thindex }, [_vm._v(_vm._s(th.title))])
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.sortTableConfig.data, function (tb, tbindex) {
          return _c(
            "tr",
            { key: tbindex, class: _vm.sortTableConfig.dashedColor },
            [
              _vm.sortTableConfig.ranking
                ? _c("td", [_vm._v("no." + _vm._s(tbindex + 1))])
                : _vm._e(),
              _vm._v(" "),
              _vm.sortTableConfig.product
                ? _c(
                    "td",
                    {
                      staticClass: "tdImg",
                      on: {
                        mouseover: function ($event) {
                          return _vm.overStyle(tbindex)
                        },
                        mouseout: function ($event) {
                          return _vm.outStyle(tbindex)
                        },
                      },
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: tbindex === _vm.row,
                            expression: "tbindex === row",
                          },
                        ],
                        attrs: {
                          src: tb.commodity ? tb.commodity.src : "",
                          alt: "",
                        },
                      }),
                      _vm._v(_vm._s(tb.commodity ? tb.commodity.text : "")),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.sortTableConfig.columns, function (th, thindex) {
                return _c("td", { key: thindex }, [
                  _vm._v(_vm._s(tb[th.key]) + "\n                "),
                ])
              }),
            ],
            2
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }